import { render, staticRenderFns } from "./UserAgreementModal.vue?vue&type=template&id=3704085e&scoped=true"
import script from "./UserAgreementModal.vue?vue&type=script&lang=js"
export * from "./UserAgreementModal.vue?vue&type=script&lang=js"
import style0 from "./UserAgreementModal.vue?vue&type=style&index=0&id=3704085e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3704085e",
  null
  
)

export default component.exports